import {
  CourseOrderRow,
  DiscountType,
  EventOrderRow,
  PartialLabelData,
  PassRow,
  PaymentLinkRow,
  PrivateOrderRow,
  RecurringPassChargeRow,
  RefundRow,
  SavedCardChargeRow,
  VoucherRow,
} from '../../../api';
import { PeriodKey, SectionType } from '../sectionMeta';

export type RawRow =
  | EventOrderRow
  | PrivateOrderRow
  | CourseOrderRow
  | VoucherRow
  | PassRow
  | RecurringPassChargeRow
  | PaymentLinkRow
  | SavedCardChargeRow
  | RefundRow;

export type RowDiscount = { code?: string; value: number; type: DiscountType };

export type UnifiedRow = {
  key: string;
  sectionType: SectionType;
  period: PeriodKey;
  entityId: string;
  orderNumber?: number;
  orderPageId?: string;
  orderPageLabel?: PartialLabelData;
  locationId?: string;
  code?: string;
  personName?: string;
  persons?: number;
  price: number;
  date: string;
  discount?: RowDiscount;
  raw: RawRow;
};

export const extractDiscount = (r: unknown): RowDiscount | undefined => {
  const raw = r as {
    discount_code?: string;
    discount_percentage?: number;
    discount_fixed_value?: number;
  };
  if (raw.discount_percentage) {
    return { code: raw.discount_code, value: raw.discount_percentage, type: DiscountType.PERCENT };
  }
  if (raw.discount_fixed_value) {
    return { code: raw.discount_code, value: raw.discount_fixed_value, type: DiscountType.FIXED };
  }
  return undefined;
};

export const buildPersonName = (firstname?: string, lastname?: string): string | undefined => {
  const joined = [firstname, lastname].filter(Boolean).join(' ').trim();
  return joined || undefined;
};
